import { CALL_API } from '../../middleware/api';
export var FETCH_RECHARGE_BIRONEX = 'FETCH_RECHARGE_BIRONEX';
export var SUCCESS_FETCH_RECHARGE_BIRONEX = 'SUCCESS_FETCH_RECHARGE_BIRONEX';
export var FAILURE_FETCH_RECHARGE_BIRONEX = 'FAILURE_FETCH_RECHARGE_BIRONEX';
export var FETCH_CREATE_RECHARGE_BIRONEX = 'FETCH_CREATE_RECHARGE_BIRONEX';
export var SUCCESS_FETCH_CREATE_RECHARGE_BIRONEX = 'SUCCESS_FETCH_CREATE_RECHARGE_BIRONEX';
export var FAILURE_FETCH_CREATE_RECHARGE_BIRONEX = 'FAILURE_FETCH_CREATE_RECHARGE_BIRONEX';
export var INIT_RECHARGE_BIRONEX = 'INIT_RECHARGE_BIRONEX';
export var RESTORE_RECHARGE_BIRONEX_BLOCK = 'RESTORE_RECHARGE_BIRONEX_BLOCK';
export var CLEAR_RECHARGE_BIRONEX_BLOCK = 'CLEAR_RECHARGE_BIRONEX_BLOCK';
export function checkRechargeBironex(data) {
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: FETCH_RECHARGE_BIRONEX
            },
            _a[CALL_API] = {
                endpoint: "/bironex-check?gamblerId=".concat(data.gamblerId, "&pin=").concat(data.pin),
                method: 'get',
                types: [
                    SUCCESS_FETCH_RECHARGE_BIRONEX,
                    FAILURE_FETCH_RECHARGE_BIRONEX
                ],
                data: data
            },
            _a));
    };
}
export function createRechargeBironex(data) {
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: FETCH_CREATE_RECHARGE_BIRONEX
            },
            _a[CALL_API] = {
                endpoint: "/payment/bironex/",
                method: 'post',
                types: [
                    SUCCESS_FETCH_CREATE_RECHARGE_BIRONEX,
                    FAILURE_FETCH_CREATE_RECHARGE_BIRONEX
                ],
                data: data
            },
            _a));
    };
}
export function checkRechargeUsdt(data) {
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: FETCH_RECHARGE_BIRONEX
            },
            _a[CALL_API] = {
                endpoint: "/usdt?gamblerId=".concat(data.gamblerId, "&pin=").concat(data.pin),
                method: 'get',
                types: [
                    SUCCESS_FETCH_RECHARGE_BIRONEX,
                    FAILURE_FETCH_RECHARGE_BIRONEX
                ],
                data: data
            },
            _a));
    };
}
export function createRechargeUsdt(data) {
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: FETCH_CREATE_RECHARGE_BIRONEX
            },
            _a[CALL_API] = {
                endpoint: "/usdt/create-invoice",
                method: 'post',
                types: [
                    SUCCESS_FETCH_CREATE_RECHARGE_BIRONEX,
                    FAILURE_FETCH_CREATE_RECHARGE_BIRONEX
                ],
                data: data
            },
            _a));
    };
}
export function initRechargeBironex() {
    return { type: INIT_RECHARGE_BIRONEX };
}
export function restoreRechargeBironexBlock(data) {
    return { type: RESTORE_RECHARGE_BIRONEX_BLOCK, data: data };
}
export function clearRechargeBironexBlock() {
    return { type: CLEAR_RECHARGE_BIRONEX_BLOCK };
}



// WEBPACK FOOTER //
// ./src/actions/bironex/index.js